import { Document, Font, Page, StyleSheet, View } from '@react-pdf/renderer';
import { VocabProvider } from '@vocab/react';

import { TalPdfFooter } from './footer';
import { TalPdfHeader } from './header';
import { TalPdfSummary, type PdfDataSummary } from './summary';

Font.register({
  family: 'SeekSans',
  fonts: [
    {
      src: 'https://seek-shared-static-assets.s3.ap-southeast-2.amazonaws.com/static/shared-web/SEEKSans-Latin-Regular-e8afb4047edc1d279a35f9c327a58db2.woff',
      fontWeight: 400,
    },
    {
      src: 'https://seek-shared-static-assets.s3.ap-southeast-2.amazonaws.com/static/shared-web/SEEKSans-Latin-Medium-33ee823026b461fd5f8519b9ec890974.woff',
      fontWeight: 700,
    },
  ],
});
Font.register({
  family: 'SeekSans Thai',
  fonts: [
    {
      src: 'https://seek-shared-static-assets.s3.ap-southeast-2.amazonaws.com/static/shared-web/SEEKSans-Thai-Regular-d1179b08eeaec0e32a695e5d2e72bf9f.woff',
      fontWeight: 400,
    },
    {
      src: 'https://seek-shared-static-assets.s3.ap-southeast-2.amazonaws.com/static/shared-web/SEEKSans-Thai-Medium-66b5f82427aa0e37e92cef3799f49e2a.woff',
      fontWeight: 700,
    },
  ],
});
const style = StyleSheet.create({
  container: {
    maxWidth: '660px',
    margin: '60px auto',
    display: 'flex',
    flexDirection: 'column',
  },
});

export const PdfDoc = ({
  data,
  language,
  fullURL,
}: {
  data: PdfDataSummary[];
  language: string;
  fullURL: string;
}) => (
  <VocabProvider language={language}>
    <Document>
      <Page
        size="A2"
        style={{
          fontFamily: language === 'th-TH' ? 'SeekSans Thai' : 'SeekSans',
        }}
      >
        <View>
          <TalPdfHeader />
          <View style={style.container}>
            <TalPdfSummary data={data} />
            <TalPdfFooter fullURL={fullURL} />
          </View>
        </View>
      </Page>
    </Document>
  </VocabProvider>
);
